import React, { useState, useEffect } from 'react';
import { CandlestickChartIcon } from 'lucide-react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../ui/dialog";
import { Label } from "../../ui/label"
import { RadioGroup, RadioGroupItem } from "../../ui/radio-group"
import TagManager from "react-gtm-module";

function SeriesTypePicker({ setSeriesType, currentSeriesType }) {
    /* Popup for selecting the series type for the chart */

    const seriesTypes = [
        { label: "Candlestick", value: "candlestick" },
        { label: "Histogram", value: "histogram" },
        { label: "Line", value: "line" },
        { label: "Area", value: "area" },
        { label: "Bar", value: "bar" },
        { label: "Baseline", value: "baseline" },

    ]

    const handleListItemClick = (value) => {
        setSeriesType(value);
    };

    const handleOpenChange = (isOpen) => {
        TagManager.dataLayer({
            dataLayer: {
                event: 'series_type_picker_dialog',
                action: isOpen ? 'open' : 'close',
                label: currentSeriesType
            },
        });
    };

    return <>
        <Dialog onOpenChange={handleOpenChange}>
            <DialogTrigger>
                <div
                    className="flex items-center space-x-2 focus:ring-2 focus:ring-offset-2 focus:ring-white rounded-md"
                >
                    <CandlestickChartIcon size={20} />
                    <span>{currentSeriesType}</span>
                </div>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Select chart type</DialogTitle>
                </DialogHeader>
                <RadioGroup defaultValue="option-one">
                    {seriesTypes.map((seriesType) => (
                        <div key={seriesType.value} className="flex items-center space-x-2">
                            <RadioGroupItem onClick={() => handleListItemClick(seriesType.value)} value={seriesType.value} id={seriesType.value} checked={seriesType.value == currentSeriesType} />
                            <Label htmlFor={seriesType.value}>{seriesType.label}</Label>
                        </div>
                    ))}
                </RadioGroup>

            </DialogContent>
        </Dialog>
    </>
}

export default SeriesTypePicker;